import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DateFilterConfig } from "@/@types";
import moment, { Moment } from "moment";
import { ref, watch } from "vue";

export type DateRangeProps = {
  clearable?: boolean;
  range?: DateFilterConfig;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'DateRange',
  props: {
    clearable: { type: Boolean, default: true },
    range: {}
  },
  emits: ["onDateChange"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;



const date = ref([__props.range?.date_start, __props.range?.date_end]);

watch(
  () => __props.range,
  (newRange) => {
    date.value = [newRange?.date_start, newRange?.date_end];
  }
);

const handleDateChange = (newRange: any) => {
  let date_start: Moment | string = "";
  let date_end: Moment | string = "";
  if (newRange && newRange[1]) {
    date.value = newRange;
    date_start = moment(newRange[0]);
    date_end = moment(newRange[1]);
  }
  emits("onDateChange", { date_start, date_end });
};


return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createBlock(_component_VueDatePicker, {
    clearable: _ctx.clearable,
    locale: "pt-br",
    "enable-time-picker": false,
    format: "dd/MM/yyyy",
    "multi-calendars": "",
    placeholder: "Selecione o período",
    "model-value": date.value,
    "onUpdate:modelValue": handleDateChange,
    ui: {
      input: 'form-select datepicker-custom-class',
    },
    range: { maxRange: 31 }
  }, null, 8, ["clearable", "model-value"]))
}
}

})